module.exports = __webpack_public_path__ + "static/img/lottery_icon.7eccb35a.png";